import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api, formatApiErrorDetail } from "../lib/api";
import { track } from "../lib/analytics";

export const CheckoutButton = ({ plan, label, destination, sourceTripId, className = "", testId }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const go = async () => {
    track("checkout_started", { plan: plan.id, value: plan.price_aud, currency: "AUD" });
    if (!user) {
      sessionStorage.setItem("wm_checkout_intent", JSON.stringify({ plan: plan.id, destination, sourceTripId }));
      toast("Sign in or create a free account to continue to payment");
      navigate("/auth");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { plan: plan.id, origin_url: window.location.origin, destination: destination || null, source_trip_id: sourceTripId || null });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't start checkout");
      setBusy(false);
    }
  };

  return (
    <button onClick={go} disabled={busy} className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#C8553D] text-[#FDFBF7] text-sm hover:bg-[#a8412f] disabled:opacity-60 transition-colors ${className}`} data-testid={testId}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null} {label} {!busy && <ArrowRight className="w-4 h-4" />}
    </button>
  );
};
